import { Link } from 'react-router';

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="inline-flex items-baseline text-[22px] font-semibold tracking-[-0.045em] text-foreground no-underline">
      {compact ? 'a4' : 'activ4'}<span className="text-primary">plus</span>
    </Link>
  );
}

